import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const LoanHistoryDetailLazy = lazyLoader(
  () =>
    import('./LoanHistoryDetail' /* webpackChunkName: "loan-history-detail" */),
);

const LoanHistoryDetail = () => {
  return (
    <Suspense fallback={null}>
      <LoanHistoryDetailLazy />
    </Suspense>
  );
};

export default LoanHistoryDetail;
